export default __webpack_public_path__ + "static/media/church_maxime_sunset.ef34698a.jpeg";